import React from 'react';
import { connect } from 'react-redux';

import BuildingAttributes from 'app/shared/components/postingPath/BuildingAttributes';
import ContactInformation from 'app/shared/components/postingPath/ContactInformation';
import FloorplansMF from 'app/shared/components/postingPath/FloorplansMF';
import HousingConnector from 'app/shared/components/postingPath/HousingConnector';
import ListingDetailsMF from 'app/shared/components/postingPath/ListingDetailsMF';
import ListingStatus from 'app/shared/components/postingPath/ListingStatus';
import Media from 'app/shared/components/postingPath/Media';
import PropertyAmenities from 'app/shared/components/postingPath/PropertyAmenities';
import SpecialOffers from 'app/shared/components/postingPath/SpecialOffers';
import UnitAmenities from 'app/shared/components/postingPath/UnitAmenities';
import userUtils from 'app/shared/utils/userUtils';

import { AppSelectors, UserSelectors } from 'app/shared/selectors';

import { StyledHR } from 'app/shared/styledComponents';

const MultiFamilyForm = ({
    address,
    cityStateZip,
    contactNameRef,
    contactPhoneRef,
    descriptionRef,
    errorObj,
    floorplansRef,
    formData,
    forRentByRef,
    getActiveFloorplanOrUnitCount,
    immediateUpdateAndSave,
    isAddingUnit,
    isInputFormDisabled,
    isListingPhotoProcessing,
    isPaymentRequired,
    isScreenSM,
    isScreenXS,
    isSeattleHousingConnector,
    listing,
    listingTitleRef,
    photosRef,
    propertyId,
    saveFloorplanData,
    savePropertyData,
    setRef,
    statusMessage,
    updateBuildingAttributeFormData,
    updateErrorObj,
    updateFormData,
    updateListingPhotoProcessingStatus,
    updateOnFocus,
    updateParentFloorplanPrice,
    updateStatusMessage,
    user,
    userRoles,
    validateFloorplan,
    validateFloorplans,
    validateUnit,
}) => {
    const { features: { canUpdateListing } } = user;
    const isPostingPathAdmin = userUtils.isPostingPathAdmin(userRoles);
    const { active, seattleHousingConnectorStatus, syndication } = formData;

    return (
        <div>
            {active && (
                <ListingStatus
                    canUpdateListing={canUpdateListing}
                    syndication={syndication}
                    isCommunity={true}
                    listing={listing}
                    address={address}
                    cityStateZip={cityStateZip}
                />
            )}
            <ListingDetailsMF
                errorObj={errorObj}
                formData={formData}
                isListingPhotoProcessing={isListingPhotoProcessing}
                propertyId={propertyId}
                savePropertyData={savePropertyData}
                updateErrorObj={updateErrorObj}
                updateFormData={updateFormData}
                updateOnFocus={updateOnFocus}
                updateStatusMessage={updateStatusMessage}
                isPostingPathAdmin={isPostingPathAdmin}
                isInputFormDisabled={isInputFormDisabled}
                descriptionRef={descriptionRef}
                listingTitleRef={listingTitleRef}
            />
            <div ref={photosRef} />
            <Media
                errorObj={errorObj}
                formData={formData}
                hasError={Boolean(errorObj.photos)}
                propertyId={propertyId}
                isListingPhotoProcessing={isListingPhotoProcessing}
                updateListingPhotoProcessingStatus={updateListingPhotoProcessingStatus}
                updateFormData={updateFormData}
                updateErrorObj={updateErrorObj}
                updateStatusMessage={updateStatusMessage}
                statusMessage={statusMessage}
                isInputFormDisabled={isInputFormDisabled}
                tour={formData.tour}
                tourType="amenity"
            />
            <StyledHR />
            <div ref={floorplansRef} />
            <FloorplansMF
                errorObj={errorObj}
                formData={formData}
                getActiveFloorplanOrUnitCount={getActiveFloorplanOrUnitCount}
                isAddingUnit={isAddingUnit}
                isInputFormDisabled={isInputFormDisabled}
                isListingPhotoProcessing={isListingPhotoProcessing}
                isMobile={isScreenXS || isScreenSM}
                isPostingPathAdmin={isPostingPathAdmin}
                propertyId={propertyId}
                saveFloorplanData={saveFloorplanData}
                updateErrorObj={updateErrorObj}
                updateFormData={updateFormData}
                updateListingPhotoProcessingStatus={updateListingPhotoProcessingStatus}
                updateOnFocus={updateOnFocus}
                updateParentFloorplanPrice={updateParentFloorplanPrice}
                updateStatusMessage={updateStatusMessage}
                validateFloorplan={validateFloorplan}
                validateFloorplans={validateFloorplans}
                validateUnit={validateUnit}
            />
            <StyledHR />
            <SpecialOffers
                propertyId={propertyId}
                specialOffers={formData.specialOffers}
                updateStatusMessage={updateStatusMessage}
                updateFormData={updateFormData}
                formData={formData}
                isInputFormDisabled={isInputFormDisabled}
                setRef={setRef}
            />
            <StyledHR />
            <ContactInformation
                contactNameRef={contactNameRef}
                contactPhoneRef={contactPhoneRef}
                errorObj={errorObj}
                formData={formData}
                forRentByRef={forRentByRef}
                immediateUpdateAndSave={immediateUpdateAndSave}
                isInputFormDisabled={isInputFormDisabled}
                isPaymentRequired={isPaymentRequired}
                savePropertyData={savePropertyData}
                updateErrorObj={updateErrorObj}
                updateFormData={updateFormData}
                updateOnFocus={updateOnFocus}
                updateStatusMessage={updateStatusMessage}
            />
            <StyledHR />
            <PropertyAmenities
                errorObj={errorObj}
                formData={formData}
                immediateUpdateAndSave={immediateUpdateAndSave}
                propertyId={propertyId}
                updateFormData={updateFormData}
                updateStatusMessage={updateStatusMessage}
                isInputFormDisabled={isInputFormDisabled}
            />
            <StyledHR />
            <BuildingAttributes
                errorObj={errorObj}
                formData={formData}
                immediateUpdateAndSave={immediateUpdateAndSave}
                savePropertyData={savePropertyData}
                updateErrorObj={updateErrorObj}
                updateFormData={updateFormData}
                updateBuildingAttributeFormData={updateBuildingAttributeFormData}
                updateOnFocus={updateOnFocus}
                updateStatusMessage={updateStatusMessage}
                userRoles={userRoles}
                isInputFormDisabled={isInputFormDisabled}
            />
            <StyledHR />
            <UnitAmenities
                errorObj={errorObj}
                formData={formData}
                immediateUpdateAndSave={immediateUpdateAndSave}
                propertyId={propertyId}
                updateFormData={updateFormData}
                updateStatusMessage={updateStatusMessage}
                isInputFormDisabled={isInputFormDisabled}
            />
            {isSeattleHousingConnector && (
                <React.Fragment>
                    <StyledHR />
                    <HousingConnector
                        initSelectedOption={seattleHousingConnectorStatus}
                        handleSelectChange={immediateUpdateAndSave}
                    />
                </React.Fragment>
            )}
        </div>
    );
};

const mapStateToProps = state => ({
    userRoles: UserSelectors.makeRoles(state),
    isSeattleHousingConnector: UserSelectors.makeIsSeattleHousingConnector(state),
    isScreenXS: AppSelectors.makeIsScreenXS(state),
    isScreenSM: AppSelectors.makeIsScreenSM(state),
    user: UserSelectors.makeUser(state),
});

export { MultiFamilyForm };
export default connect(mapStateToProps)(MultiFamilyForm);
